<!--~
~ Copyright (c) 2010-2020 California CAD Solutions, Inc. Licensed subject
~ to an End-User License Agreement included in a separate file named EULA.txt
~ that is distributed with this file.
-->
@if (datasourceCreated$ | async) {
    @switch (dataSource.reportSubType$ | async) {
        @case ('detail') {
            <dash-gis-report-content-detail [definition]="definition"
                                            [keys]="keys"
                                            [dataSource]="dataSource"
                                            [dataForm]="tableDataForm"
                                            [dataFormGroup]="tableEditFormGroup"
                                            [tableEditActive]="tableEditActive"
                                            fxLayout="column" fxFlex="1 1 auto"></dash-gis-report-content-detail>
        }
        @case ('tabular') {
            <dash-gis-report-content-tabular [definition]="definition"
                                             [keys]="keys"
                                             [dataSource]="dataSource"
                                             [dataFormGroup]="tableEditFormGroup"
                                             [dataForm]="tableDataForm"
                                             [tableEditActive]="tableEditActive"
                                             [mapEnabled]="mapEnabled"
                                             (editRowData)="onEditRowData($event)"
                                             fxLayout="column" fxFlex="1 1 auto"></dash-gis-report-content-tabular>
        }
        @case ('chart') {
            <dash-gis-report-content-chart [definition]="definition"
                                           [keys]="keys"
                                           [dataSource]="dataSource" fxFill></dash-gis-report-content-chart>
        }
        @case ('label') {
            <dash-gis-report-content-pdf [definition]="definition"
                                         [keys]="keys"
                                         [dataSource]="dataSource"></dash-gis-report-content-pdf>
        }
        @case ('csv') {
        }
        @case ('empty') {
            <ng-container *ngTemplateOutlet="emptyTemplate"></ng-container>
        }
        @case ('error') {
            <ng-container *ngTemplateOutlet="errorTemplate"></ng-container>
        }
        @default {
            <div class="overlay loading-container loading">
                <mat-progress-spinner mode="indeterminate" diameter="60" strokeWidth="15"></mat-progress-spinner>
                <div class="report-loading-overlay"></div>
            </div>
        }
    }
}
<!-- empty -->
<ng-template #emptyTemplate>
    <div>No records found</div>
</ng-template>

<ng-template #errorTemplate>
    <div class="report-error">Error fetching report data</div>
</ng-template>

